import { momentTitle, VERDICT_TITLES, type AiMoment, type AiNotes } from './ai-notes';
import { FALSE_ALARM_TIER, NO_SIGNAL_TIER, noteTier, reasonTier } from './ranking';
import type { EventInfo, ReasonKind } from './reasons';

export type BadgeTone = 'incident' | 'user' | 'nearby' | 'quiet';

export interface Badge {
  readonly label: string;
  readonly tone: BadgeTone;
}

const INCIDENT_TIER = 3;
const NEARBY_TIER = 6;
const REASON_TONES: Readonly<Record<ReasonKind, BadgeTone>> = {
  bump: 'incident',
  aeb: 'incident',
  handle: 'incident',
  manual: 'user',
  honk: 'user',
  object: 'quiet',
  none: 'quiet',
  unknown: 'quiet',
};

export const toneOfTier = (tier: number): BadgeTone => (tier <= INCIDENT_TIER ? 'incident' : tier <= NEARBY_TIER ? 'nearby' : 'quiet');

const strongestNote = (notes: AiNotes | undefined): AiMoment | undefined =>
  notes?.moments.reduce<AiMoment | undefined>((best, moment) => (best === undefined || noteTier(moment) < noteTier(best) ? moment : best), undefined);

export function badgeOf(info: EventInfo | undefined, notes: AiNotes | undefined, tier: number): Badge {
  if (tier === FALSE_ALARM_TIER) return { label: VERDICT_TITLES.false_alarm, tone: 'quiet' };
  const reason = info?.reason;
  const note = strongestNote(notes);
  if (note && noteTier(note) < (reason ? reasonTier(reason) : NO_SIGNAL_TIER)) return { label: momentTitle(note), tone: toneOfTier(noteTier(note)) };
  return reason ? { label: reason.label, tone: REASON_TONES[reason.kind] } : { label: 'Recording', tone: 'quiet' };
}
